import type { IconDef } from '../types';

export const profile: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M17.0459 14.7969C20.3305 14.7969 22.9998 17.4499 23 20.7148V22.5205C22.9999 23.3391 22.3352 23.9999 21.5117 24H2.48828C1.6647 24 1.00011 23.3391 1 22.5205V20.7148C1.00008 19.1368 1.61501 17.6478 2.74609 16.5332C3.87738 15.4186 5.36633 14.7969 6.9541 14.7969H17.0459ZM7.07227 16.5527C6.01071 16.5035 4.99866 16.8779 4.21484 17.5879C3.43095 18.298 2.97433 19.2748 2.93457 20.3203L2.875 21.6328L20.8867 22.4121L20.9463 21.0996C21.0454 18.9297 19.3383 17.0851 17.1553 16.9863L7.07227 16.5527ZM12.4121 0C15.9645 0.000263408 18.8623 2.88091 18.8623 6.41211C18.8623 9.94332 15.9645 12.824 12.4121 12.8242C8.85947 12.8242 5.96094 9.94348 5.96094 6.41211C5.96094 2.88074 8.85948 0 12.4121 0ZM15.7363 3.10742C14.0692 1.45024 11.2107 1.56868 9.38477 3.39355C7.55888 5.20853 7.42963 8.04984 9.09668 9.70703C10.7638 11.3642 13.6223 11.2457 15.4482 9.4209C17.2742 7.59605 17.4034 4.76461 15.7363 3.10742Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    },
  ],
};
